import {ReactNode, CSSProperties} from "react";
import {MuiTheme} from "material-ui/styles";
import muiThemeable from "material-ui/styles/muiThemeable";

import {mergeStyles} from "src/utils/components";

function getStyle(props: {muiTheme: MuiTheme}) {
  const {width} = props.muiTheme.drawer!;

  return {
    width,
  };
}


interface DrawerProps {
  children?: ReactNode;
  style?: CSSProperties;
}


const Drawer = muiThemeable()<DrawerProps>(
  (props) => {
    return <div style={mergeStyles(getStyle(props), props.style)}>
      {props.children}
    </div>;
  },
);


export default Drawer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Drawer.tsx